
// import { useBusinessFormState } from './useBusinessFormState'; // Replaced by context
// import { useBusinessFormValidation } from './useBusinessFormValidation'; // Validation now runs inside context
// import { useFormAccordionState } from './useFormAccordionState'; // Accordion state now in context
import { useBusinessSelection } from './useBusinessSelection';
import { useFormSubmit } from './useFormSubmit';
// import { useSectionCompletion } from './useSectionCompletion'; // Section completion/edited state now in context
// import { useSectionNavigation } from './useSectionNavigation'; // Not directly used for returned values here
import { useBusinessFormContext } from '@/context/BusinessFormContext';
import { BusinessDetails as FormBusinessDetails } from '../../addBusinessModal/types';


export const useFirstBusinessForm = (onComplete: (businessId: string) => void) => {
  const {
    // States from context
    businessDetails,
    userEmail,
    marketingOptIn,
    // selectedDate, // context has selectedDate, useBusinessSelection will use context's handleDateSelect

    // Setters/handlers from context
    setFormSection,
    setBusinessDetails, // from context, for useBusinessSelection
    handleDateSelect,   // from context, for useBusinessSelection
    // No need for most other handlers here as components call context handlers directly
  } = useBusinessFormContext();
  
  // Adapt useBusinessSelection to use context setters
  const { handleBusinessSelect, handleCreateNew } = useBusinessSelection(
    setBusinessDetails, // context's setter
    handleDateSelect,   // context's date handler (which also sets selectedDate in context)
    setFormSection      // context's form section setter
  );

  // Adapt useFormSubmit to use context state
  const { handleSubmit, isSubmitting, formError } = useFormSubmit(
    businessDetails as FormBusinessDetails, // businessDetails from context
    userEmail,                              // userEmail from context
    onComplete,
    marketingOptIn                          // marketingOptIn from context
  );

  // The handleWebsiteBlur from context can be used directly by BasicInfoFormSection.
  // If useFirstBusinessForm needs to expose a specific version, it can be defined here.
  // For now, assuming components will use the one from context if needed.

  // Most of the state and handlers previously returned by this hook are now directly
  // available to components via useBusinessFormContext.
  // This hook now primarily orchestrates a few top-level actions/handlers
  // by composing other hooks that are now context-aware.

  return {
    handleBusinessSelect, // For SearchSection
    handleCreateNew,      // For SearchSection
    handleSubmit,         // For FormContent's main submit button
    isSubmitting,         // Pass through isSubmitting
    formError,            // Pass through formError
    // Other specific handlers or derived states that *only* FirstBusinessForm needs
    // and are not suitable for direct component consumption via context.
    // For this refactor, most things have moved to context.
  };
};
